import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';

export default function Lister({
  sectionTitle,
  description,
  data
}) {
  return (
    <div className="cs_shape_wrap">
      <div className="cs_shape_1" />
      <div className="container">
        <SectionHeading title={sectionTitle} center />
        <Spacing md="50" lg="30" />
        <p className='text-justify'>{description}</p>
        <Spacing md="30" lg="20" />
        <div className='row w-100'>
          {data?.map((item, index) => (
            <div className='col-sm-6'><ul><li>{item.title}</li></ul></div>
          ))}
        </div>
      </div>
    </div>
  );
}
